import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/{-$locale}/_auth/settings')({
  component: RouteComponent
});

function RouteComponent() {
  return <div>Hello "/-$locale/_auth/settings"!</div>;
}
